import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { DynamicField } from '@totalsoft/rocket-ui';
import { ParamsContext } from 'providers/ParamsContext';
import { getDynamicFieldControlType } from 'utils/functions';

const FacilityKpiIndicatorsComponent = ({
  index,
  itemTypeId,
  itemTypeName,
  indicatorId,
  indicatorValue,
  indicatorName,
  indicatorPropertyTypeCode,
  handleChange,
  isSaving,
  disabled
}) => {
  const { cvsChAmount } = useContext(ParamsContext);
  return (
    <Grid item xs={6}>
      <DynamicField
        fullWidth={true}
        value={indicatorValue}
        controlType={getDynamicFieldControlType(indicatorPropertyTypeCode)}
        label={indicatorName + ' - ' + itemTypeName}
        id={indicatorId + '-' + itemTypeId}
        disabled={isSaving || disabled}
        onChange={handleChange(index)}
        inputProps={{ decimalScale: cvsChAmount }}
      />
    </Grid>
  );
};

FacilityKpiIndicatorsComponent.propTypes = {
  index: PropTypes.number.isRequired,
  itemTypeId: PropTypes.number.isRequired,
  itemTypeName: PropTypes.string.isRequired,
  indicatorId: PropTypes.number.isRequired,
  indicatorValue: PropTypes.string,
  indicatorName: PropTypes.string.isRequired,
  indicatorPropertyTypeCode: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};

export default FacilityKpiIndicatorsComponent;
